import { IotError } from "@core/domain/errors/iot.error.ts";

export class HttpFailedRequestError<T = unknown> extends IotError {
    constructor(
        public readonly httpCode: number,
        public readonly errorCode?: number,
        public readonly errorDescription?: string,

        public readonly data?: T,
    ) {
        let message = `Http error (${httpCode})`;
        if (errorCode) message += ` - ${errorCode}`;
        if (errorDescription) message += ` - ${errorDescription}`;

        super(message);

        Object.setPrototypeOf(this, HttpFailedRequestError.prototype);
    }
}
